import PropTypes from 'prop-types';
import cn from "../../../../../utils/cn";
import { get, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import DraftEditorField from "../../../../Form/DraftEditorField/DraftEditorField";
import ExpandableContainer from "../../../ExpandableContainer/ExpandableContainer";
import HoursOfOperation from "../../../HoursOfOperation/HoursOfOperation";
import ContactInformation from "../../../Contact/ContactInformation/ContactInformation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ProviderDescription = _ref => {
  let {
    className = '',
    provider,
    isInNetworkGroup = true,
    showMore = false,
    intlProvider = {}
  } = _ref;
  const description = get(provider, 'description');
  const {
    email_addresses,
    phone_numbers,
    primary_contact_name,
    website_url
  } = provider;
  const showContactInfo = !isEmpty(email_addresses) || !isEmpty(phone_numbers) || !isEmpty(primary_contact_name) || !isEmpty(website_url);
  const headerText = !isEmpty(intlProvider) ? /*#__PURE__*/_jsx(FormattedMessage, {
    id: "Z+Mo8M",
    description: "org-contact-header",
    defaultMessage: "Organization Contact Information",
    children: txt => /*#__PURE__*/_jsx("div", {
      children: txt
    })
  }) : 'Organization Contact Information';
  return /*#__PURE__*/_jsx("div", {
    className: cn('provider-description', className),
    children: /*#__PURE__*/_jsxs(ExpandableContainer, {
      controlled: true,
      hideToggle: true,
      id: "detail-description-expandable",
      isOpen: showMore,
      showGradient: false,
      useFirstChildHeight: !showMore,
      children: [description && /*#__PURE__*/_jsx("div", {
        className: `${showContactInfo ? 'mb-4' : ''}`,
        children: /*#__PURE__*/_jsx(DraftEditorField, {
          hideLabel: true,
          id: `description-${get(provider, 'id')}`,
          label: "Description",
          readOnly: true,
          value: description,
          readOnlyClass: "text-base"
        })
      }), showContactInfo && /*#__PURE__*/_jsx(ContactInformation, {
        email_addresses: email_addresses,
        headerText: headerText,
        isInNetworkGroup: isInNetworkGroup,
        phone_numbers: phone_numbers,
        primary_contact_name: primary_contact_name,
        showMore: showMore,
        website_url: website_url
      }), !isEmpty(provider.hours) && /*#__PURE__*/_jsx(HoursOfOperation, {
        hours: provider.hours,
        isInNetworkGroup: isInNetworkGroup,
        showAll: showMore,
        showHoursIcon: true,
        showMore: showMore,
        showToggle: showMore,
        intlProvider: intlProvider
      })]
    })
  });
};
ProviderDescription.propTypes = {
  className: PropTypes.string,
  showMore: PropTypes.bool,
  provider: PropTypes.object.isRequired,
  isInNetworkGroup: PropTypes.bool,
  intlProvider: PropTypes.object
};
export default ProviderDescription;
//# sourceMappingURL=ProviderDescription.js.map